import { Component } from '@angular/core';

@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet>',
  providers: []
})
export class AppComponent { }



// WEBPACK FOOTER //
// ./src/app/app.component.ts